// Joint appointment for several projects (setter spec §08.4, §08.5, UAT-34). Schemas in api-joint-appointment.ts.
import * as J from './api-joint-appointment.js';
import { IdParam, route, W } from './route-def.js';

export const jointAppointmentRoutes = {
  getJointAppointmentOptions: route({
    method: 'GET', path: '/workspaces/:workspaceId/contacts/:contactId/joint-appointment', summary: 'Cita conjunta: otros proyectos del prospecto y si un asesor puede presentarlos juntos', tag: 'appointments',
    minRole: 'advisor', params: W({ contactId: IdParam }), query: J.JointAppointmentQuerySchema, response: J.JointAppointmentOptionsSchema,
  }),
} as const;
